import wixLocation from 'wix-location';
import wixWindow from 'wix-window';
import { biLoggerFactory } from 'wix-private';
const biLogger = biLoggerFactory('lp', 19, { msid: 'd119b397-8d57-4d3c-9bcb-8127dbee7a46' });
import wixAnimations from 'wix-animations';
let timeline1 = wixAnimations.timeline();
let timeline2 = wixAnimations.timeline();
let timeline3 = wixAnimations.timeline();
let timeline4 = wixAnimations.timeline();
let timeline5 = wixAnimations.timeline();
let timeline6 = wixAnimations.timeline();
let timeline7 = wixAnimations.timeline();
let timeline8 = wixAnimations.timeline();
let timeline9 = wixAnimations.timeline();
let timeline10 = wixAnimations.timeline();
let timeline11 = wixAnimations.timeline();
let timeline12 = wixAnimations.timeline();
let currentSlide = 1;

const userReviewInfo = {
    1: {
        review: '“Galaxy is geweldig. Ze waren super punctueel en communiceerden heel goed. Ik raad ze je echt aan als je snel werk moet afleveren, de website die ze voor mij hebben gemaakt is fantastisch.”',
        name: "Isaiah Christopher Thomas",
        website: '<p class=font_7><span>eCommerce Website <span><u><a href="https://nl.wix.com/marketplace/wix-partner/galaxy-visual-media" target="_blank">Galaxy Visual Media</a></u></span></span></p>',
        image: 'https://static.wixstatic.com/media/0784b1_8d39df323fda4a69808f469dc352ca6f~mv2.png',
    },
    2: {
        review: '“Ik vond het geweldig om met Dave en Bethany samen te werken. Ze luisterden goed en communiceerden regelmatig met me gedurende het hele proces. Het was een topsamenwerking, en ik ben super gelukkig met het eindproduct.”',
        name: 'Rosana Maria Salcedo ',
        website: '<p class=font_7><span>herontwerp van de website <span><u><a href="https://nl.wix.com/marketplace/wix-partner/lets-design-your-site#projects" target="_blank"> Let’s Design Your Site</a></u></span></span></p>',
        image: 'https://static.wixstatic.com/media/0784b1_c4c795282158444da3db338a3def64f3~mv2.png'
    },
    3: {
        review: "“Celine was super om mee te werken! Ze heeft geweldig werk geleverd bij het ontwerpen van mijn website en begreep precies wat ik zocht. Ze luisterde naar mijn wensen en creëerde iets veel beters dan ik me had kunnen voorstellen. Ze levert echt werk van hoge kwaliteit.    Als je overweegt iemand in te huren om je te helpen bij het ontwerpproces, dan kan ik Celine TEN ZEERSTE aanbevelen. Dit was zo'n goede investering, echt meer dan de moeite waard!”",
        name: "Madison Griffith",
        website: '<p class=font_7><span>herontwerp van de website <span><u><a href="https://nl.wix.com/marketplace/wix-partner/celine-kir-creative" target="_blank"> Celine Kir Creative</a></u></span></span></p>',
        image: 'https://static.wixstatic.com/media/0784b1_b4eee6f4de0f4ed1a91e758cf3dace78~mv2.png',
    },
    4: {
        review: "“Fantastische service! Geweldige, professionele website! Ik kan Sara van harte bij iedereen aanbevelen. Na de eerste betaling was alles binnen een week klaar.”",
        name: "Lisa White",
        website: '<p class=font_7><span>herontwerp van de website <span><u><a href="https://nl.wix.com/marketplace/wix-partner/sara-michelle-design#projects" target="_blank"> Sara Michelle Design </a></u></span></span></p>',
        image: 'https://static.wixstatic.com/media/0784b1_fe5d41c6faf044359b54c11a652278d2~mv2.png'
    },
    5: {
        review: "“Celine was super om mee te werken! Ze heeft geweldig werk geleverd bij het ontwerpen van mijn website en begreep precies wat ik zocht. Ze luisterde naar mijn behoeften en creëerde iets veel beters dan ik me had kunnen voorstellen; werk van hoge kwaliteit. \n Als je overweegt iemand in te huren om te helpen bij het ontwerpproces, raad ik Celine TEN ZEERSTE aan. Dus de moeite waard, dit was de beste investering!”",
        name: "Madison Griffith",
        website: '<p class=font_7><span>herontwerp van de website <span><u><a href="https://nl.wix.com/marketplace/wix-partner/celine-kir-creative#projects" target="_blank"> Celine Kir Creative</a></u></span></span></p>',
        image: 'https://static.wixstatic.com/media/0784b1_b4eee6f4de0f4ed1a91e758cf3dace78~mv2.png',
    },
    6: {
        review: "“Fantastische service! Geweldige, professionele website! Ik kan Sara van harte bij iedereen aanbevelen. Na de eerste betaling was alles binnen een week klaar.”",
        name: "Lisa White",
        website: '<p class=font_7><span>herontwerp van de website <span><u><a href="https://nl.wix.com/marketplace/wix-partner/sara-michelle-design#projects" target="_blank"> Sara Michelle Design </a></u></span></span></p>',
        image: 'https://static.wixstatic.com/media/0784b1_fe5d41c6faf044359b54c11a652278d2~mv2.png'
    },
}

$w.onReady(function () {

});
async function fireEvent(button, additionalInfo) {
    const biEventObject = {
        evid: 703,
        button_name: button,
        is_valid: true,
        topic: 'wix partners site',
        url: wixLocation.url,
        Additional_info: additionalInfo
    };
    await biLogger.log(biEventObject);
}

export function getStartedTopFold_click(event) {
    fireEvent('Get Started', 'Top fold')
}

export function exploreNowWebDesignContainer_click(event) {
    fireEvent('Explore Now', 'Explore services fold: Web Design')
}

export function exploreNowMarketingContainer_click(event) {
    fireEvent('Explore Now', 'Explore services fold: Marketing & Promoting')
}

export function exploreNowSmallTasksContainer_click(event) {
    fireEvent('Explore Now', 'Explore services fold: Small Tasks')
}

export function exploreNowOnlineStoresContainer_click(event) {
    fireEvent('Explore Now', 'Explore services fold: Online Store')
}

export function exploreNowGraphicDesignContainer_click(event) {
    fireEvent('Explore Now', 'Explore services fold: Graphic Design')
}

export function exploreNowWebDevelopmentContainer_click(event) {
    fireEvent('Explore Now', 'Explore services fold: Web Development')
}

export function getStartedBottomeFoldContainer_click(event) {
    fireEvent('Get Started', 'Bottom fold')
}

export function arrowRight_click(event) {
    fireEvent('Right Arrow', 'Showcase fold')
    const review = $w('#review');
    const reviewer = $w('#reviewer');
    const revieweWebsite = $w('#reviewWebiste');
    const imageArray = [$w("#image1"), $w("#image2"), $w("#image3"), $w("#image4")]
    const image4 = $w("#image4");
    const image1 = $w("#image1");
    const image2 = $w("#image2");
    const image3 = $w("#image3");
    const image5 = $w("#image3a");
    const image6 = $w("#image4a");

    if (wixWindow.formFactor === 'Mobile') {
        if (currentSlide == 4) {
            currentSlide = 1
        } else {
            currentSlide = currentSlide + 1
        }
        review.text = userReviewInfo[currentSlide]['review']
        reviewer.text = userReviewInfo[currentSlide]['name']
        revieweWebsite.html = userReviewInfo[currentSlide]['website']
        imageArray[currentSlide - 1].show()

        if (currentSlide === 1) {
            imageArray[3].hide()
        } else {
            imageArray[currentSlide - 2].hide()
        }
    } else {
        if (currentSlide === 6) {
            currentSlide = 1
        } else {
            currentSlide = currentSlide + 1
            if (currentSlide === 4) {
                $w('#arrowRight').hide()
            }
            if (currentSlide !== 5) {
                $w('#arrowLeft').show()
            }
        }
        wixWindow.getBoundingRect()
            .then((windowSizeInfo) => {
                let windowWidth = windowSizeInfo.window.width;
                let movingdistance = windowWidth * 0.60
                review.text = userReviewInfo[currentSlide]['review']
                reviewer.text = userReviewInfo[currentSlide]['name']
                revieweWebsite.html = userReviewInfo[currentSlide]['website']
                if (currentSlide <= 4) {
                    movingdistance = -movingdistance
                }
                let curDistance = (currentSlide - 1) % 4
                timeline1.add(image4, {
                    "duration": 1000,
                    "x": movingdistance * curDistance
                })
                timeline2.add(image1, {
                    "x": movingdistance * curDistance,
                    "duration": 1000,
                })
                timeline3.add(image2, {
                    "x": movingdistance * curDistance,
                    "duration": 1000,
                })
                timeline4.add(image3, {
                    "x": movingdistance * curDistance,
                    "duration": 1000,
                })
                timeline11.add(image5, {
                    "x": movingdistance * curDistance,
                    "duration": 1000,
                })
                timeline12.add(image6, {
                    "x": movingdistance * curDistance,
                    "duration": 1000,
                })
                timeline1.play()
                timeline2.play()
                timeline3.play()
                timeline4.play()
                timeline11.play()
                timeline12.play()
            });
    }

}

export function arrowLeft_click(event) {
    fireEvent('Left Arrow', 'Showcase fold')
    const review = $w('#review');
    const reviewer = $w('#reviewer');
    const revieweWebsite = $w('#reviewWebiste');
    const imageArray = [$w("#image1"), $w("#image2"), $w("#image3"), $w("#image4")]
    const image4 = $w("#image4");
    const image1 = $w("#image1");
    const image2 = $w("#image2");
    const image3 = $w("#image3");
    const image5 = $w("#image3a");
    const image6 = $w("#image4a");

    if (wixWindow.formFactor === 'Mobile') {
        if (currentSlide == 1) {
            currentSlide = 4
        } else {
            currentSlide = currentSlide - 1
        }
        review.text = userReviewInfo[currentSlide]['review']
        reviewer.text = userReviewInfo[currentSlide]['name']
        revieweWebsite.html = userReviewInfo[currentSlide]['website']
        imageArray[currentSlide - 1].show()

        if (currentSlide === 4) {
            imageArray[0].hide()
        } else {
            imageArray[currentSlide].hide()
        }
    } else {
        if (currentSlide == 1) {
            currentSlide = 6
        } else {
            currentSlide = currentSlide - 1
        }
        if (currentSlide !== 4) {
            $w('#arrowRight').show()
        }
        if (currentSlide === 5) {
            $w('#arrowLeft').hide()
        }
        wixWindow.getBoundingRect()
            .then((windowSizeInfo) => {
                let windowWidth = windowSizeInfo.window.width;
                let movingdistance = windowWidth * 0.60
                review.text = userReviewInfo[currentSlide]['review']
                reviewer.text = userReviewInfo[currentSlide]['name']
                revieweWebsite.html = userReviewInfo[currentSlide]['website']
                if (currentSlide <= 4) {
                    movingdistance = -movingdistance
                }
                let curDistance = (currentSlide - 1) % 4
                if (currentSlide === 5) {
                    curDistance = 2
                }
                timeline1.add(image1, {
                    "duration": 1000,
                    "x": movingdistance * curDistance
                })
                timeline2.add(image2, {
                    "x": movingdistance * curDistance,
                    "duration": 1000,
                })
                timeline3.add(image3, {
                    "x": movingdistance * curDistance,
                    "duration": 1000,
                })
                timeline4.add(image4, {
                    "x": movingdistance * curDistance,
                    "duration": 1000,
                })
                timeline11.add(image5, {
                    "x": movingdistance * curDistance,
                    "duration": 1000,
                })
                timeline12.add(image6, {
                    "x": movingdistance * curDistance,
                    "duration": 1000,
                })
                timeline1.play()
                timeline2.play()
                timeline3.play()
                timeline4.play()
                timeline11.play()
                timeline12.play()
            });
    }
}

// export function box66_mouseIn(event) {
//     $w('#imageX65').show()
//     timeline5
//         .add($w('#imageX51'), { opacity: 0, duration: 500, easing: 'easeOutExpo' })
//         .add($w('#imageX66'), { opacity: 1, duration: 500, easing: 'easeInExpo' })

//         .play()

//     timeline6.add($w('#imageX50'), { opacity: 0, duration: 500, easing: 'easeOutExpo' })
//         .add($w('#imageX64'), { opacity: 1, duration: 500, easing: 'easeInExpo' })
//         .play()

//     timeline7.add($w('#imageX49'), { opacity: 0, duration: 500, easing: 'easeOutExpo' })
//         .add($w('#imageX62'), { opacity: 1, duration: 500, easing: 'easeInExpo' })
//         .play()

//     timeline8.add($w('#imageX54'), { opacity: 0, duration: 500, easing: 'easeOutExpo' })
//         .add($w('#imageX61'), { opacity: 1, duration: 500, easing: 'easeInExpo' })
//         .play()

//     timeline9.add($w('#imageX68'), { opacity: 1, duration: 500, easing: 'easeInExpo' }).play()
//     timeline10.add($w('#imageX63'), { opacity: 1, duration: 500, easing: 'easeInExpo' }).play()
// }

// export function box66_mouseOut(event) {
//     $w('#imageX65').hide()
//     timeline5.add($w('#imageX51'), { opacity: 1, duration: 500, easing: 'easeOutExpo' })
//         .add($w('#imageX66'), { opacity: 0, duration: 500, easing: 'easeInExpo' })
//         .play()

//     timeline6.add($w('#imageX50'), { opacity: 1, duration: 500, easing: 'easeOutExpo' })
//         .add($w('#imageX64'), { opacity: 0, duration: 500, easing: 'easeInExpo' })
//         .play()

//     timeline7.add($w('#imageX49'), { opacity: 1, duration: 500, easing: 'easeOutExpo' })
//         .add($w('#imageX62'), { opacity: 0, duration: 500, easing: 'easeInExpo' })
//         .play()

//     timeline8.add($w('#imageX54'), { opacity: 1, duration: 500, easing: 'easeOutExpo' })
//         .add($w('#imageX61'), { opacity: 0, duration: 500, easing: 'easeInExpo' })
//         .play()

//     timeline9.add($w('#imageX68'), { opacity: 0, duration: 500, easing: 'easeInExpo' }).play()

//     timeline10.add($w('#imageX63'), { opacity: 0, duration: 500, easing: 'easeInExpo' }).play()
// }